import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPerson = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M13.4375 5.625C13.2844 7.69023 11.7188 9.375 10 9.375C8.28125 9.375 6.71289 7.69063 6.5625 5.625C6.40625 3.47656 7.92969 1.875 10 1.875C12.0703 1.875 13.5938 3.51562 13.4375 5.625Z",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		id: "Vector_2",
		d: "M10 11.875C6.60156 11.875 3.15234 13.75 2.51406 17.2891C2.43711 17.7156 2.67852 18.125 3.125 18.125H16.875C17.3219 18.125 17.5633 17.7156 17.4863 17.2891C16.8477 13.75 13.3984 11.875 10 11.875Z",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeMiterlimit: 10
	})]
});
export default SvgPerson;
